import { PlaybookStatus } from '@driftt/api-types'
import { A, Div, Tag } from '@driftt/tide-core'
import { Modal, ModalBody, ModalTitle } from '@driftt/tide-modal'
import { pluralize } from 'humanize-plus'
import React from 'react'

import { HydratedPlaybookBlockData } from '.'
import { splitArchivedPlaybooks } from './helpers'

import styles from './styles.module.css'

interface Props {
  isOpen: boolean
  onClose: () => void
  consumingPlaybooks: HydratedPlaybookBlockData[]
}

const ArchivedPlaybooksModal = ({
  isOpen,
  onClose,
  consumingPlaybooks,
}: Props) => {
  const { archived } = React.useMemo(
    () => splitArchivedPlaybooks(consumingPlaybooks),
    [consumingPlaybooks]
  )

  return (
    <Modal open={isOpen} onClose={onClose} size="small">
      <ModalTitle>
        {`Block used in ${archived.length || 0} ${pluralize(
          archived.length,
          'playbook'
        )}`}
      </ModalTitle>
      <ModalBody>
        <Div className={styles.usedInModalSubheader}>
          {pluralize(archived.length, 'Playbook')} where this block is used:
        </Div>
        <Div className={styles.usedInModalPbList}>
          {archived.map(({ playbook: pb }, index) => {
            return (
              <Div key={index} className={styles.pbRow}>
                <Div className={styles.pbDetails}>
                  <Tag
                    wrapperClass={styles.pbArchivedStatus}
                    type="default"
                    text={PlaybookStatus.ARCHIVED}
                  />
                  <A
                    href={`/playbooks/editor/${pb.id}/visual-builder`}
                    className={styles.pbName}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {pb.name}
                  </A>
                </Div>
              </Div>
            )
          })}
        </Div>
      </ModalBody>
    </Modal>
  )
}

export default ArchivedPlaybooksModal
